import { useSelector } from 'react-redux';
import { getBrandKitId } from 'ContentData/selectors/branding';
import Routes from 'ContentUtils/Routes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIIconButton from 'UIComponents/button/UIIconButton';
import InheritanceTypes from 'ContentUtils/constants/CustomWidgetInheritanceTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.${key}`;
const FieldInheritanceIcon = ({
  inheritedValue,
  isDefaultValue,
  onResetClick,
  onUnlinkClick,
  scrollToField
}) => {
  const {
    inheritanceType,
    inheritanceFieldKey,
    inheritanceFieldLabel
  } = inheritedValue || {};
  const brandKitId = useSelector(getBrandKitId);
  if (!inheritanceType) return null;
  let tooltipTitle;
  if (inheritanceType === InheritanceTypes.brandSettings) {
    tooltipTitle = isDefaultValue ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: i18nKey('inheritanceTooltip.brandSettings_jsx'),
      options: {
        href: Routes.brandSettings(brandKitId)
      },
      elements: {
        Link: UILink
      }
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('inheritanceTooltip.reset.brandSettings')
    });
  } else if (inheritanceFieldLabel) {
    if (isDefaultValue) {
      tooltipTitle = scrollToField ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: i18nKey('inheritanceTooltip.field_jsx'),
        options: {
          onClick: () => {
            scrollToField({
              fieldKey: inheritanceFieldKey
            });
          },
          inheritanceFieldLabel
        },
        elements: {
          Link: UILink
        }
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('inheritanceTooltip.field'),
        options: {
          inheritanceFieldLabel
        }
      });
    } else {
      tooltipTitle = /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('inheritanceTooltip.reset.field'),
        options: {
          inheritanceFieldLabel
        }
      });
    }
  }
  return tooltipTitle ? /*#__PURE__*/_jsx(UIIconButton, {
    className: "m-left-1",
    onClick: isDefaultValue ? onUnlinkClick : onResetClick,
    size: "sm",
    tooltip: tooltipTitle,
    use: "link",
    children: /*#__PURE__*/_jsx(UIIcon, {
      name: isDefaultValue ? 'link' : 'unlink'
    })
  }) : null;
};
export default FieldInheritanceIcon;